import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-agendador`

    return {
        index() {
            return repository.get(`${baseUrl}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getMunicipios(queryParms) {
            return repository.get(`${baseUrl}/municipio?${urlUtil.serialize(queryParms)}`)
        },
        getDestinos(queryParms) {
            return repository.get(`${baseUrl}/destino?${urlUtil.serialize(queryParms)}`)
        },
        getHorarios(queryParms) {
            return repository.get(`${baseUrl}/horario?${urlUtil.serialize(queryParms)}`)
        },
        getPacientes(queryParms) {
            return repository.get(`${baseUrl}/paciente?${urlUtil.serialize(queryParms)}`)
        },
    }
}